import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const ReadMessage = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      viewBox="0 0 28.42823 24.49425"
      width={size}
      height={size}
      fill={iconColor}
      stroke={iconColor}
    >
      <title>{iconTitle}</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_2-2" data-name="Layer 2">
          <path d="M28.36827,23.4621a1.057,1.057,0,0,0,.02789-.13788V7.3833a1.071,1.071,0,0,0-.03491-.17255.74253.74253,0,0,0-.71472-.96319h-1.889V0H2.94889V6.24756H.78666a.7433.7433,0,0,0-.71484.96277,1.06829,1.06829,0,0,0-.035.173V23.32422a1.06048,1.06048,0,0,0,.02509.124.74775.74775,0,0,0,.98151.9856,1.05631,1.05631,0,0,0,.12915.02612H27.26042a1.06587,1.06587,0,0,0,.14917-.03021.73185.73185,0,0,0,.95868-.96765ZM24.75749,1V8.11285L14.19358,15.8255,3.94889,8.3147V1ZM13.78813,16.96875a.74926.74926,0,0,0,.85742,0L26.89616,8.4342V22.18445l-7.6261-5.895L25.85447,22.96H2.579l6.58441-6.67047L1.53678,22.18475V8.434Z" />
        </g>
      </g>
    </svg>
  );
};

ReadMessage.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

ReadMessage.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(ReadMessage);
